import api from 'api/api'
import { toast } from "react-toastify"

import { API_URL } from 'constants/index'

export const GET_ALL_SERIES = "[SERIES] GET ALL SERIES"

export const CRUD_SERIE = "[SERIES] CRUD SERIE"

export function getAllSeries() {
  const request = api.get(`/serie`)
  return (dispatch) =>
    request.then((response) => {
      dispatch({ type: GET_ALL_SERIES, payload: response.data.detalles })
    }).catch((err) => {
      dispatch({ type: GET_ALL_SERIES, payload: null })
      toast.error("Error inesperado. No se pudo obtener las series")
      console.log(err)
    })
}

export function saveSerie(form) {
  const request = api.post(`/rserie`, form)
  return (dispatch) => {
    dispatch({ type: CRUD_SERIE, payload: { loading: true } })
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        dispatch({ type: CRUD_SERIE, payload: { loading: false, crud: true } })
        toast.success(response.data.message)
      } else {
        toast.error(response.data.message)
      }
      return setTimeout(() => {
        dispatch({ type: CRUD_SERIE, payload: { loading: false, crud: false } })
      }, 50)
    }).catch((err) => {
      dispatch({ type: CRUD_SERIE, payload: { loading: false, crud: false } })
      toast.error("Error inesperado. No se pudo registrar la serie")
      console.log(err)
    })
  }
}

export function updateSerie(form) {
  const request = api.post(`/aserie`, form)
  return (dispatch) => {
    dispatch({ type: CRUD_SERIE, payload: { loading: true } })
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        dispatch({ type: CRUD_SERIE, payload: { loading: false, crud: true } })
        toast.success(response.data.message)
      } else {
        toast.error(response.data.message)
      }
      return setTimeout(() => {
        dispatch({ type: CRUD_SERIE, payload: { loading: false, crud: false } })
      }, 50)
    }).catch((err) => {
      dispatch({ type: CRUD_SERIE, payload: { loading: false, crud: false } })
      toast.error("Error inesperado. No se pudo actualizar la serie")
      console.log(err)
    })
  }
}

export function deleteSerie(form) {
  const request = api.post(`/eserie`, form)
  return (dispatch) => {
    toast.info("Borrando serie...", { toastId: "deleteSerie", autoClose: false })
    dispatch({ type: CRUD_SERIE, payload: { loading: true } })
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        dispatch({ type: CRUD_SERIE, payload: { loading: false, crud: true } })
        toast.success(response.data.message, { toastId: "deleteSerie", autoClose: 5000 })
      } else {
        toast.error(response.data.message, { toastId: "deleteSerie", autoClose: 5000 })
      }
      return setTimeout(() => {
        dispatch({ type: CRUD_SERIE, payload: { loading: false, crud: false } })
      }, 50)
    }).catch((err) => {
      dispatch({ type: CRUD_SERIE, payload: { loading: false, crud: false } })
      toast.error("Error inesperado. No se pudo borrar la serie", { toastId: "deleteSerie", autoClose: 5000 })
      console.log(err)
    })
  }
}

export function updateSerieStatus(form) {
  const request = api.post(`/cserie`, form)
  return (dispatch) => {
    toast.info("Actualizando estado...", { toastId: "updateSerieStatus", autoClose: false })
    dispatch({ type: CRUD_SERIE, payload: { loading: true } })
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        dispatch({ type: CRUD_SERIE, payload: { loading: false, crud: true } })
        toast.success(response.data.message, { toastId: "updateSerieStatus", autoClose: 5000 })
      } else {
        toast.error(response.data.message, { toastId: "updateSerieStatus", autoClose: 5000 })
      }
      return setTimeout(() => {
        dispatch({ type: CRUD_SERIE, payload: { loading: false, crud: false } })
      }, 50)
    }).catch((err) => {
      dispatch({ type: CRUD_SERIE, payload: { loading: false, crud: false } })
      toast.error("Error inesperado. No se pudo actualizar el estado de la serie", { toastId: "updateSerieStatus", autoClose: 5000 })
      console.log(err)
    })
  }
}
